import styled from "styled-components";
import { type Fn } from "@bagel-web/common";
import { HighlightedText } from "../agent/stateComponents/SimpleComponentVisualization";

const FunctionCallContainer = styled.span`
  font-family: monospace;
  color: var(--bs-code-color);
`;

function FunctionCall({
  selectedFn,
  textHighlight,
  showMessageWhitespace = true,
}: {
  selectedFn: Fn;
  textHighlight?: string;
  showMessageWhitespace?: boolean;
}) {
  const argsText = Object.keys(selectedFn.args)
    .map((argName) => {
      const prettyValue = JSON.stringify(
        selectedFn.args[argName],
        null,
        showMessageWhitespace ? 2 : 0
      );
      return `${argName}=${prettyValue}`;
    })
    .join(", ");
  return (
    <FunctionCallContainer
      className={showMessageWhitespace ? "pre-wrap" : "wrap"}
    >
      <HighlightedText
        text={`${selectedFn.name}(${argsText})`}
        textFilter={textHighlight}
      />
    </FunctionCallContainer>
  );
}

export default FunctionCall;
